/**
 * User-related TypeScript types matching backend schemas
 */

export enum UserRole {
  ADMIN = 'admin',
  INSTRUCTOR = 'instructor',
  LEARNER = 'learner'
}

export interface User {
  id: number;
  username: string;
  email: string;
  role: UserRole;
  is_active: boolean;
  first_name?: string | null;
  last_name?: string | null;
  display_name?: string | null;
  cohort?: string | null;
  assigned_instructor_id?: number | null;
  assigned_instructor?: UserReference | null;
  must_change_password?: boolean;
  password_reset_at?: string | null;
  password_reset_expires_at?: string | null;
  created_at: string;
  updated_at: string;
}

export interface UserReference {
  id: number;
  username: string;
  email: string;
  role: UserRole;
  first_name?: string | null;
  last_name?: string | null;
  display_name?: string | null;
  cohort?: string | null;
}

export interface UserWithSSHKeys extends User {
  ssh_keys: SSHKey[];
}

export interface SSHKey {
  id: number;
  name: string;
  public_key: string;
  fingerprint: string;
  key_type: string;
  user_id: number;
  created_at: string;
}

export interface UserCreate {
  username: string;
  email: string;
  password: string;
  role?: UserRole;
  is_active?: boolean;
  first_name?: string | null;
  last_name?: string | null;
  cohort?: string | null;
  assigned_instructor_id?: number | null;
}

export interface UserUpdate {
  username?: string;
  email?: string;
  role?: UserRole;
  is_active?: boolean;
  first_name?: string | null;
  last_name?: string | null;
  cohort?: string | null;
  assigned_instructor_id?: number | null;
}

export interface UserProfileUpdate {
  first_name?: string | null;
  last_name?: string | null;
  cohort?: string | null;
}

export interface SSHKeyCreate {
  name: string;
  public_key: string;
}

export interface LoginRequest {
  username: string;
  password: string;
}

export interface RegisterRequest {
  username: string;
  email: string;
  password: string;
  confirm_password: string;
}

export interface ChangePasswordRequest {
  current_password: string;
  new_password: string;
}

export interface Token {
  access_token: string;
  token_type: string;
}

export interface TokenData {
  username?: string;
  user_id?: number;
  role?: UserRole;
}
